<coa-dashboard-offline-traffic-content
  [categoryId]="categoryId"
  [clientId]="clientId"
  [paymentsEnabled]="paymentsEnabled$ | async"
  [timePeriod]="timePeriod"
  [uniqueEnabled]="uniqueEnabled$ | async"
  class="dashboard-offline-traffic-content"
  data-cy="dashboard.offline-traffic-content">
</coa-dashboard-offline-traffic-content>
